import { render, staticRenderFns } from "./OptimizedPortfolioToggle.vue?vue&type=template&id=01db72f4&scoped=true&"
import script from "./OptimizedPortfolioToggle.vue?vue&type=script&lang=js&"
export * from "./OptimizedPortfolioToggle.vue?vue&type=script&lang=js&"
import style0 from "./OptimizedPortfolioToggle.vue?vue&type=style&index=0&id=01db72f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db72f4",
  null
  
)

export default component.exports